import React, { useEffect, useRef } from 'react';

import { useBrandContext } from '../../contexts/BrandContext';
import { useAPI } from '../../libs/libAPI';
import ThemeType from '../../types/ThemeType';

interface EmbededFrameProps extends React.IframeHTMLAttributes<HTMLIFrameElement> {
  id: string;
  entity: string;
  activityId: string;
  htmlContent: string;
}

const IMAGE_FIX_CSS = 'img { filter: invert(1); color: #fff; }';
const DARK_IMAGE_FIX_CSS = `<style>${IMAGE_FIX_CSS}</style>`;
const DYNAMIC_IMAGE_FIX_CSS = `<style>@media (prefers-color-scheme: dark) { ${IMAGE_FIX_CSS} }</style>`;

const EmbededFrame: React.FC<EmbededFrameProps> = (props) => {
  const api = useAPI();
  const { themeType } = useBrandContext();

  const { htmlContent, id, entity, activityId, className, ...otherProps } = props;

  const ref = useRef<any>();

  useEffect(() => {
    const blobs: string[] = [];
    const iframeLoad = (): void => {
      const imgElements: HTMLImageElement[] = ref.current?.contentDocument?.getElementsByTagName('img');
      if (imgElements != null) {
        Array.from(imgElements).forEach((element: HTMLImageElement) => {
          if (element.hasAttribute('data-attachment-id')) {
            const attachmentId = element.getAttribute('data-attachment-id')!;
            console.log(attachmentId)
            void (async () => {
              const response = await api.fetch(`${import.meta.env.VITE_API_URI}/v1/${entity}/${id}/activity/${activityId}/attachments/${attachmentId}`, {
                method: 'GET'
              });

              if (response.ok) {
                const blob = await response.blob();
                const url = URL.createObjectURL(blob);
                blobs.push(url);
                element.src = url;
              }
            })();
          }
        });
      }

      if (ref.current != null) {
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions, @typescript-eslint/restrict-plus-operands
        ref.current.style.height = `${(ref.current.contentDocument?.body.scrollHeight ?? 100) + 25}px`;
      }
    };

    const iframeDomLoad = () => {
      
    };

    ref.current?.addEventListener('load', iframeLoad);
    ref.current?.addEventListener('DOMContentLoaded', iframeDomLoad);

    return () => {
      ref.current?.removeEventListener('load', iframeLoad);
      ref.current?.removeEventListener('DOMContentLoaded', iframeDomLoad);
      blobs.forEach((blob) => URL.revokeObjectURL(blob));
    };
  }, [ref]);

  const htmlSrc = `<base target="_blank" />${htmlContent}${themeType === ThemeType.Dark ? DARK_IMAGE_FIX_CSS : ''}${themeType === ThemeType.Dynamic ? DYNAMIC_IMAGE_FIX_CSS : ''}`;

  return <iframe srcDoc={htmlSrc} {...otherProps} className={`${themeType === ThemeType.Dynamic ? 'dark:invert' : ''} ${themeType === ThemeType.Dark ? 'invert' : ''} ${className ?? ''}`} ref={ref} />;
};

export default EmbededFrame;
